export default {
      id: "share-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite.svg#share",
      toString: function () {
        return this.url;
      }
    }